import Vue from 'vue'
import VueCordova from 'vue-cordova'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueLazyload from "vue-lazyload";

import App from './components/App'
import router from './router'
import store from './store'
import './bootstrap'
import {getUrl, trace_log} from "./util";
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.config.productionTip = false

Vue.use(VueCordova)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: 'img/etc/notfound.png',
	loading: 'img/etc/nowloading.png',
	attempt: 1
})

const init = () => {
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
};

document.addEventListener("deviceready", () => {
	// 接続先URLを取得
	getUrl(getUrlCallback);
});

function getUrlCallback() {
	FastClick.attach(document.body);

	// デバイス存在チェック
	NativeStorage.getItem("device_id", getSuccessDeviceId, getErrorDeviceId);
}

function getSuccessDeviceId(obj) {
	trace_log("生成済みdeviceId:" + obj)
	init()
}

function getErrorDeviceId(error) {
	// 該当アイテムなし(NativeStorageError.ITEM_NOT_FOUND)
	if (error.code === 2) {
		// デバイスIDは固定値で発行
		NativeStorage.setItem("device_id", "device_browser", setSuccessDeviceId, setErrorDeviceId)

	}
	else
	{
		if (error.exception !== "") {
			trace_log("予期せぬ例外:" + error.exception)
		}
		else {
			trace_log("予期せぬエラー:" + error.code)
		}
	}
}

function setSuccessDeviceId(obj) {
	// デバイスID発行成功
	trace_log("新規作成deviceId:" + obj)
	init()
}

function setErrorDeviceId(error) {
	trace_log(error.code);
	if (error.exception !== "") {
		trace_log(error.exception)
	}
}
